import React from "react";

const Footer = () => {
  return (
    <div className="h-10 w-full dark:text-white text-golden font-para dark:bg-[linear-gradient(to_right,rgba(30,41,59,0),rgba(30,41,59,0.5),rgba(30,41,59,0))]  dark:bg-black bg-darkbrown flex justify-center items-center">
      Made with ❤️ Harsh Prajapat
    </div>
  );
};

export default Footer;
